import axios from 'axios'

const live = {}
// 删除直播
live.del = params => { return axios.get('/video/live/del', {params}) }
// 加载单个
live.load = params => { return axios.get('/video/live/load', {params}) }
// 查询直播
live.find = params => { return axios.get('/video/live/find', {params}) }
// 保存直播
live.save = params => { return axios.post('/video/live/save', params) }
// 查询时间段
live.findTime = params => { return axios.get('/video/live/time/find', {params}) }
// 删除时间段
live.delTime = params => { return axios.post('/video/live/time/del', params) }
// 保存直播时间
live.saveTime = params => { return axios.post('/video/live/time/save', params) }

// 停播
live.stop = params => { return axios.get('/video/live/stop', {params}) }
export default live



// WEBPACK FOOTER //
// ./src/api/live.js